module.exports = __webpack_public_path__ + "img/ST.0e9692a1.png";